import Vue from 'vue'
import Vuex from 'vuex'
import SaleAnalysis from './modules/SaleAnalysis';
import EquipAnalysis from './modules/EquipAnalysis';
import CommonSearch from './modules/CommonSearch';
import SearchEquip from './modules/SearchEquip';
import DepthAnalysis from './modules/DepthAnalysis';
import reports from './modules/reports'
import home from './modules/home'
import user from './modules/user'
import schema from './modules/schema'
import gain from './modules/gain';
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isLoggedIn: false,
        loadingCount: 0,
        leftCollapse:true,
        indexLoadingCount:0,
    },
    getters: {
        isLoggedIn: (state) => {
            return state.isLoggedIn;  
        },
        loadingCount: (state) => {
            return state.loadingCount;
        },
        indexLoadingCount:(state)=>{
            return state.indexLoadingCount;
        },
        leftCollapse: (state) => {
            return state.leftCollapse;
        }
    },
    mutations: {
        setLoggedIn(state, isLoggedIn) {
            state.isLoggedIn = isLoggedIn;  
        },
        startLoading(state) {
            state.loadingCount += 1;
        },

        startIndexLoading(state){
            state.indexLoadingCount +=1;
        },
        stopLoading(state) {
            state.loadingCount -= 1;
            if(state.loadingCount < 0) {
                state.loadingCount = 0;
            }
        },
        stopIndexLoading(state) {
            state.indexLoadingCount -= 1;
            if(state.indexLoadingCount < 0) {
                state.indexLoadingCount = 0;
            }
        },
        setLeftCollapse(state,isCollapse){
           state.leftCollapse = isCollapse;
        }
    },
    actions: {
    },
    modules: {
        saleanalysis: SaleAnalysis,
        equipanalysis:EquipAnalysis,
        commonsearch:CommonSearch,
        searchequip:SearchEquip,
        depthanalysis:DepthAnalysis,
        schema:schema,
        reports,
        home,
        user,
        gain

    }
});